// SVARĪGI: Dublikāts no styled.js pielāgots izmantošanai meklētāja ievadlaukam kā atsevišķai sekcijai

import styled, { css } from 'styled-components';
import { rem, em } from 'polished';
import { Button } from 'elements';
import {
  accessibilityBorder,
  colors,
  themed,
} from 'core/theme';
import { Flex, media } from 'core/layout';

const padding = (props) => {
  return css`
    padding: ${em(16)} ${em(48)} ${em(16)} ${em(52)};
  `;
}

export const StyledSearch = styled.div`
  border-bottom: 1px solid ${colors.hairline};
  font-size: ${rem(16)};
  padding: 1.5em 0;
  z-index: 50;

  display: flex;
  align-items: center;
  justify-content: center;

  /* IE flexbox fix */
  & > div {
    margin: 0;
  }

  ${({open}) => !open && css`
    display: none;
  `};
`;

const backgroundColor = (props) => themed(
  Object.assign({}, colors.lightThemed, {
    light: colors.HIGHLIGHT,
  })
);

export const IconWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.5em 1em;
  height: 100%;
  pointer-events: none;

  display: flex;
  flex-direction: column;
  justify-content: center;

  > i {
    color: ${colors.secondary};
  }
`

export const Form = styled.form`
  position: relative;

  input {
    background-color: ${backgroundColor};
    border: 1px solid ${colors.hairline};
    color: ${colors.text};
    font-size: ${em(16)};
    ${padding};
    width: 100%;

    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }

    &::-ms-clear {
      display: none;
    }

    &:not([value=""]) + label > span {
      display: none;
    }

    ${accessibilityBorder};
  }
`;

export const Wrapper = styled.div`
  width: 100%;
`;

const labelColor = (props) => themed(
  Object.assign({}, colors.darkThemed, {
    light: colors.B54,
  })
);

export const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;

  color: ${labelColor};
  ${padding};
`;

export const CloseContainer = Flex.extend`
  justify-content: flex-end;
  margin: 0 0 ${em(8)};

  & > div {
    padding-top: 0;
  }

  ${media.tablet`
    margin: 0;

    & > div {
      display: flex;
      justify-content: flex-end;
    }
  `};
`;

// FIXME: Kāpēc class secība ir apgriesta?
export const CloseButton = styled(Button)`
  color: ${colors.secondary};
`;

export const InputContainer = Flex.extend`
  margin: ${em(21)} 0;

  & > div {
    padding-top: 0;
    padding-left: 0;
  }

  ${media.tablet`
    margin: ${em(12)} 0;

    & > div {
      flex: 0 0 100%;
    }
  `};
`;

export const HiddenSubmit = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    width: 5em !important;
    height: 100%;
    z-index: 1;
    visibility: hidden;
    padding: 0.5em !important;
`;



// WEBPACK FOOTER //
// ./src/modules/Header/components/Search/styled-2.js